export default __webpack_public_path__ + "static/media/image-board-study-now-n-w@2x.ba367926.png";